/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_FailInputs */



/**
* | output |
* | --- |
* | "Fail" |
*
* @param {Context_Menu_FailInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_fail = /** @type {((inputs?: Context_Menu_FailInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_FailInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rejeter")
	if (locale === "de") return /** @type {LocalizedString} */ ("Scheitern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fallire")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Неудача")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fallar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("失敗")
	if (locale === "hi") return /** @type {LocalizedString} */ ("असफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falhar")
	return /** @type {LocalizedString} */ ("Fail")
});